import { h } from 'preact';
export const Feather = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("path", { d: "M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z" }),
        h("line", { x1: "16", y1: "8", x2: "2", y2: "22" }),
        h("line", { x1: "17.5", y1: "15", x2: "9", y2: "15" })));
};
//# sourceMappingURL=feather.js.map